export interface DataType{
  id: number,
  name: string,
  createTime: string,
  mobile: string,
  userName: string,
  customerServiceUrl: string,
}

export const column = [
  { title: '商户ID', dataIndex: 'id', key: 'id' },
  { title: '名称', dataIndex: 'name', key: 'name' },
  { title: '创建时间', dataIndex: 'createTime', key: 'createTime' }, 
  { title: '客服IM地址', dataIndex: 'customerServiceUrl', key: 'customerServiceUrl' }, 
]